import React from 'react';
import { Segment, Image, Header } from 'semantic-ui-react';
import QuestionImage from '../../resources/images/question.svg';

export default (props) => {
    var {lang} = props;
    return (
        <a href={`mailto:lina@novameta.lt?subject=${lang.subject_label}`}><Segment basic>
            <Header style={{ margin: "0.5rem auto", fontWeight: "500", fontSize: "20pt"}}>
            <Image style={{margin: "0 auto" }} draggable="false" src={QuestionImage} />
            <span style={{margin: "0 1rem"}}>{lang.questions_label}</span>
            </Header>
        </Segment></a>
    )
}


// WEBPACK FOOTER //
// ./src/components/questions/Question.jsx